import { Component, ViewChild, Input, Inject, AfterViewInit, OnInit, EventEmitter, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

import { GenericService } from '../../../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../../common/data.service';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadingService } from '../../../common/lazyloading';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { ScoreCardGroupScoreAnalysis, APIParamSA, QualitativeWeightedScoreResponse, FinancialIndexWithScore } from '../ScoreAnalysis/ScoreAnalysis.model'
import { FAScoringModelFinancialView, APIParam, QuantitativeGroup } from '../WFScoringQuantitativeDetail/WFScoringQuantitativeDetail.model'
import { FAScoringModelQualitativeView } from '../WFScoringQualitativeDetail/WFScoringQualitativeDetail.model'
import { JSONCurrentInstanceData } from '../../WorkflowDashBoard.model';
import { UtilityService } from '../../../common/utility.service';



@Component({
    selector: 'app-ScoreAnalysis-Component',
    templateUrl: './ScoreAnalysis.component.html',
    styleUrls: ['./ScoreAnalysis.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
///Component can be integrated with parent component 
export class ScoreAnalysis implements OnInit {



  public documentURL: string;
  public urlAarray: string[];
  public baseURL: string;
  public hostname: string;
  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public userName: string;
  public __oInstanceAllStateData: JSONCurrentInstanceData[] = [];
  public __sScoringModelName: string = '';
  public __oQuantitativeGroup: QuantitativeGroup[] = [];
  public __oQuantitativeScoreCardGroup: QuantitativeGroup[] = [];
  public __oQuantitativeView: string = 'Score Card Group';
  public __oQuantitativeViews: any[];
  public __sQuantitativeValue: string = null;
  public __sQualitativeValue: string = null;
  public __iTotalWeightGauge: number = 0;

  public __sWeightedFinancialRating: string = '';
  public __iWeightedFinancialScore: number;

  public __sWeightedQualitativeRating: string = '';
  public __iWeightedQualitativeScore: number;

  public __sWeightedIntrinsicRating: string = '';
  public __iWeightedIntrinsicScore: number;

  public __bIsLoadingVisible: boolean = false;

  onInitialized = new EventEmitter<ScoreAnalysis>();

  @Input()
  __sInstanceId: number = 0;

  @Input()
  __sStateDataId: number = 0;

  @Input()
  __sValue: any = "";

  @Input()
  __sDataCaption: string = "";

  @Input()
  __sQuantitativeControlState: string = "";

  @Input()
  __sScoringModel: string = "";

  @Input()
  __sBasePeriod: string = "";

  @Input()
  __sPeriod: string = "";

  @Input()
  __sTradingCounterparty: string = "";

  @Input()
  __sQuantitativeControl: string = "";

  @Input()
  __sQualitativeControl: string = "";

  @Input()
  __bReadOnly: number = 0;

  @Input()
  __sScoreAnalysisControl: string = "";
  



  public __oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];
  public __oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];
  public __oFAScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis[] = [];

  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public route: ActivatedRoute, public router: Router, public __oUtilityService: UtilityService, public data: DataService, public http: HttpClient, public datePipe: DatePipe, public lazyLoadingService: LazyLoadingService) {
    let sViews: any[] = [
      {
        id: 0,
        text: "Score Card Group"
      },
      {
        id: 1,
        text: "Financial Group"
      }
    ];

    this.__oQuantitativeViews = sViews;
  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);

  }

  /// Events

  public TextAreaOnChange(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == e);

    if (oExistFAScoringModelFinancialView.IsScored == 1) {

      this.service.UpdateAllDataByPromise(oExistFAScoringModelFinancialView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  public TextAreaOnChangeOriginal(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == e);

    oExistFAScoringModelFinancialView.AdjustedValue = oExistFAScoringModelFinancialView.OriginalValue;

    if (oExistFAScoringModelFinancialView.IsScored == 1) {

      this.service.UpdateAllDataByPromise(oExistFAScoringModelFinancialView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  /// component public methods can be called from parent component

  public Refresh() {

    //console.log(this.__sInstanceId);
    //console.log(this.__sStateDataId);
    //console.log(this.__sValue);
    //console.log(this.__sDataCaption);
    this.__bIsLoadingVisible = true;

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceAllStateData/" + this.__sInstanceId).then((Data) => {

      if (Data != null) {

        let sData: string = Data;

        sData = sData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine');
        //sData = this.replaceAllSpecialCharacters(sData);

        try {
          this.__oInstanceAllStateData = JSON.parse(sData);

          for (let oFSV of this.__oInstanceAllStateData) {
            if (oFSV.DataValue != undefined || oFSV.DataValue != null)
              oFSV.DataValue = this.replaceAllSpecialCharacters(oFSV.DataValue);
          }​​​

          this.__sScoringModelName = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoringModel).DataValue;

          let oAPIParam: APIParam = new APIParam();
          oAPIParam.Param = this.__sScoringModelName;

          oAPIParam.sBaseYearPeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sPeriod).DataValue;
          oAPIParam.sBasePeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sBasePeriod).DataValue;
          oAPIParam.sTradingcounterparty = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sTradingCounterparty).DataValue;


          this.__sQualitativeValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQualitativeControl).DataValue;
          this.__sQuantitativeValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQuantitativeControl).DataValue;

          if (!this.IsNullOrEmpty(this.__sScoreAnalysisControl) && (this.IsNullOrEmpty(this.__sValue) || this.__sValue == undefined)) {
            this.__sValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoreAnalysisControl).DataValue;
          }

            oAPIParam.sValue = "Plain";

            this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelFinancialView").then(
              result => this.OnSuccessGetFAScoringModelFinancial(result)
            ).
              catch(error => this.OnErrorGetFAScoringModelFinancial(error))

            this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelQualitativeView").then(
              result => this.OnSuccessGetFAScoringModelQualitative(result)
            ).
              catch(error => this.OnErrorGetFAScoringModelQualitative(error))
          
          

        }
        catch
        {
          console.log(sData);
          this.__bIsLoadingVisible = false;
        }

      }

    });



  }



  public GetData() {
    let sXML: string = '';

    sXML += '<ScoreAnalysis>';
    sXML += '<ScoringModel>' + this.__sScoringModelName + '</ScoringModel>';

    sXML += '<WeightedFinancialRating>' + this.__sWeightedFinancialRating + '</WeightedFinancialRating>';
    sXML += '<WeightedFinancialScore>' + this.__iWeightedFinancialScore.toString() + '</WeightedFinancialScore>';

    sXML += '<WeightedQualitativeRating>' + this.__sWeightedQualitativeRating + '</WeightedQualitativeRating>';
    if (!this.IsNullOrUndefined(this.__iWeightedQualitativeScore))
      sXML += '<WeightedQualitativeScore>' + this.__iWeightedQualitativeScore.toString() + '</WeightedQualitativeScore>';
    else
      sXML += '<WeightedQualitativeScore>' + this.__iWeightedQualitativeScore + '</WeightedQualitativeScore>';

    sXML += '<WeightedIntrinsicRating>' + this.__sWeightedIntrinsicRating + '</WeightedIntrinsicRating>';

    if (!this.IsNullOrUndefined(this.__iWeightedIntrinsicScore))
      sXML += '<WeightedIntrinsicScore>' + this.__iWeightedIntrinsicScore.toString() + '</WeightedIntrinsicScore>';
    else
      sXML += '<WeightedIntrinsicScore></WeightedIntrinsicScore>';

    for (let x of this.__oFAScoreCardGroupScoreAnalysis) {
      sXML += '<Data>';

      sXML += '<Id>' + x.Id + "</Id>";
      sXML += '<ScoreCardGroup>' + x.ScoreCardGroup + "</ScoreCardGroup>";
      sXML += '<Score>' + x.Score + "</Score>";
      sXML += '<Rating>' + x.Rating + "</Rating>";
      sXML += '<WeightGuage>' + x.WeightGuage + "</WeightGuage>";
      sXML += '<WeightedScore>' + x.WeightedScore + "</WeightedScore>";
      sXML += '<WeightedScoreDummy>' + x.WeightedScoreDummy + "</WeightedScoreDummy>";  
      sXML += '<Formula>' + x.Formula + "</Formula>";

      sXML += '</Data>';
    }   

    sXML += '</ScoreAnalysis>';
    return sXML;
  }

  public OnErrorGetFAScoringModelFinancial(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelFinancial(response: any) {

    if (response != null) {
      let oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];
      oFAScoringModelFinancialView = response;

      this.__oQuantitativeGroup = [];
      this.__oQuantitativeScoreCardGroup = [];

      for (let x of oFAScoringModelFinancialView) {      


        for (let x of oFAScoringModelFinancialView) {
          if (!this.IsNullOrEmpty(x.FAScoreCardGroup)) {
            if (this.__oQuantitativeScoreCardGroup.find(y => y.GroupName == x.FAScoreCardGroup) == null) {
              let oFinancialGroup: QuantitativeGroup = new QuantitativeGroup();
              oFinancialGroup.GroupName = x.FAScoreCardGroup;
              this.__oQuantitativeScoreCardGroup.push(oFinancialGroup);
            }
          }



        }
      }

        this.__oFAScoringModelFinancialView = oFAScoringModelFinancialView;


      if (!this.IsNullOrEmpty(this.__sQuantitativeValue)) {
        let sXML: string = this.__sQuantitativeValue;

          sXML = sXML.replace('<FinancialData>', '');
          sXML = sXML.replace('</FinancialData>', '');

          let iDefinitionStartIndex: number = 0;
          let iDefinitionLastIndex: number = 0;
          let sColumnData: string = "";


          iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
          iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

          sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

          let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

          sXML = sXML.replace(sColumnData, '');

          if (sScoringModel == this.__sScoringModelName) {

            let oFinancialColumns: string[] = ['FinancialFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore', 'GroupFormulaValue'];

            let iStartIndex: number = 0;
            let iLastIndex: number = 0;
            let sXMLData: string = '';
            let sNode: string = '';
            let iColumnStartIndex: number = 0;
            let iColumnLastIndex: number = 0;
            let sColumnValue: string = "";
            let sValue: any = "";
            let sData: string = '';

            let oFinancialFactors: any[] = [];

            while (sXML.trim() != '') {
              let oFinancialFactor: any = {};

              iStartIndex = sXML.indexOf("<Data>");
              iLastIndex = sXML.indexOf("</Data>");

              sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

              sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

              for (let oColumn of oFinancialColumns) {
                iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

                if (iColumnStartIndex >= 0) {
                  iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                  sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                  sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

                }

                switch (oColumn) {
                  case 'FinancialFactor':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.FinancialFactor = sValue;
                      }
                      break;
                    }
                  case 'OriginalValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.OriginalValue = sValue;
                      }
                      break;
                    }
                  case 'AdjustedValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.AdjustedValue = sValue;
                      }
                      break;
                    }
                  case 'Score':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.Score = Number(sValue);
                      }
                      break;
                    }
                  case 'Weight':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.Weight = Number(sValue);
                      }
                      break;
                    }
                  case 'WeightedScore':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.WeightedScore = Number(sValue);
                      }
                      break;
                    }
                  case 'GroupFormulaValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.GroupFormulaValue = Number(sValue);
                      }
                      break;
                    }

                }
              }

              sXML = sXML.replace(sXMLData, '');
              oFinancialFactors.push(oFinancialFactor);

            }


            for (let x of oFinancialFactors) {
              let oFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(y => y.lFAScoringModelFinancialViewId == x.FinancialFactor);

              if (oFAScoringModelFinancialView != null) {

                oFAScoringModelFinancialView.OriginalValue = x.OriginalValue;
                oFAScoringModelFinancialView.AdjustedValue = x.AdjustedValue;
                oFAScoringModelFinancialView.Score = x.Score;
                oFAScoringModelFinancialView.Weight = x.Weight;
                oFAScoringModelFinancialView.WeightedScore = x.WeightedScore;
                oFAScoringModelFinancialView.GroupFormulaValue = x.GroupFormulaValue;


              }

             

            }

          }

        }


      if (this.IsNullOrEmpty(this.__sValue)) {
        let iId: number = 1;
        this.__oFAScoreCardGroupScoreAnalysis = [];

        for (let oScoreCardGroup of this.__oQuantitativeScoreCardGroup) {
          let oScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis = new ScoreCardGroupScoreAnalysis();
          oScoreCardGroupScoreAnalysis.Id = iId;
          oScoreCardGroupScoreAnalysis.ScoreCardGroup = oScoreCardGroup.GroupName;

          if (iId == 1) {
            oScoreCardGroupScoreAnalysis.WeightGuage = 100;
          }
          else {
            oScoreCardGroupScoreAnalysis.WeightGuage = 0;
          }

          let sFormulaString = this.__oFAScoringModelFinancialView.find(x => x.FAScoreCardGroup == oScoreCardGroup.GroupName).ScoreCardGroupFormula;
          //let iSumOfWeightedScore: number = 0;

          oScoreCardGroupScoreAnalysis.Formula = sFormulaString;

          //if (this.IsNullOrEmpty(sFormulaString)) {
          //  for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup == oScoreCardGroup.GroupName && x.WeightedScore != null)) {
          //    iSumOfWeightedScore = iSumOfWeightedScore + oGroupFactor.WeightedScore;
          //  }

          //  oScoreCardGroupScoreAnalysis.Formula = iSumOfWeightedScore.toString();
          //}
          //else {
          //  sFormulaString = sFormulaString.replace("=","");

          //  for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup == oScoreCardGroup.GroupName && x.Score != null && x.Weight != null))
          //  {
          //    var regexScore: RegExp = new RegExp(oGroupFactor.ScoreIndex, "g");
          //    var regexWeight: RegExp = new RegExp(oGroupFactor.WeightIndex, "g");

          //    sFormulaString = sFormulaString.replace(regexScore, oGroupFactor.Score.toString());
          //    sFormulaString = sFormulaString.replace(regexWeight, oGroupFactor.Weight.toString());
          //  }

          //  oScoreCardGroupScoreAnalysis.Formula = sFormulaString;
          //}

          iId = iId + 1;

          this.__oFAScoreCardGroupScoreAnalysis.push(oScoreCardGroupScoreAnalysis);
        }


        let oIndexWithScore: FinancialIndexWithScore[] = [];

        for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup != null && x.Score != null && x.Weight != null)) {

          let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
          oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
          oFinancialIndexWithScore.Score = oGroupFactor.Score;

          oIndexWithScore.push(oFinancialIndexWithScore);

          let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
          oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
          oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

          oIndexWithScore.push(oFinancialIndexWithWeight);

          let oFinancialIndexWithWeightGFV: FinancialIndexWithScore = new FinancialIndexWithScore();
          oFinancialIndexWithWeightGFV.Index = oGroupFactor.GroupFormulaIndex;
          oFinancialIndexWithWeightGFV.Score = oGroupFactor.GroupFormulaValue;

          oIndexWithScore.push(oFinancialIndexWithWeightGFV);
        }


        

        let oAPIParamSA: APIParamSA = new APIParamSA();
        oAPIParamSA.ScoreCardGroupScoreAnalysis = this.__oFAScoreCardGroupScoreAnalysis;
        oAPIParamSA.FinancialIndexWithScore = oIndexWithScore;
        oAPIParamSA.sParam = this.__sScoringModelName;

        this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateScoreCardGroupRating").then(
          result => this.OnSuccessGetScoreCardGroupScoreAnalysis(result)
        ).
          catch(error => this.OnErrorGetScoreCardGroupScoreAnalysis(error))


      }
      else {
        this.PopulateScoreAnalysisData();
      }
      

      this.CalculateTotalWeightGauge();


    }
    this.__bIsLoadingVisible = false;
  }

  public OnErrorGetFAScoringModelQualitative(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelQualitative(response: any) {

    if (response != null) {
      let oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];
      oFAScoringModelQualitativeView = response;


      this.__oFAScoringModelQualitativeView = oFAScoringModelQualitativeView;


      if (!this.IsNullOrEmpty(this.__sQualitativeValue)) {
        let sXML: string = this.__sQualitativeValue;

        sXML = sXML.replace('<QualitativeData>', '');
        sXML = sXML.replace('</QualitativeData>', '');

        let iDefinitionStartIndex: number = 0;
        let iDefinitionLastIndex: number = 0;
        let sColumnData: string = "";


        iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
        iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

        sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

        let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

        sXML = sXML.replace(sColumnData, '');

        if (sScoringModel == this.__sScoringModelName) {

          let oQualitativeColumns: string[] = ['QualitativeFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore'];

          let iStartIndex: number = 0;
          let iLastIndex: number = 0;
          let sXMLData: string = '';
          let sNode: string = '';
          let iColumnStartIndex: number = 0;
          let iColumnLastIndex: number = 0;
          let sColumnValue: string = "";
          let sValue: any = "";
          let sData: string = '';

          let oQualitativeFactors: any[] = [];

          while (sXML.trim() != '') {
            let oQualitativeFactor: any = {};

            iStartIndex = sXML.indexOf("<Data>");
            iLastIndex = sXML.indexOf("</Data>");

            sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

            sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

            for (let oColumn of oQualitativeColumns) {
              iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

              if (iColumnStartIndex >= 0) {
                iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

              }

              switch (oColumn) {
                case 'QualitativeFactor':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.QualitativeFactor = sValue;
                    }
                    break;
                  }
                case 'OriginalValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.OriginalValue = sValue;
                    }
                    break;
                  }
                case 'AdjustedValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.AdjustedValue = sValue;
                    }
                    break;
                  }
                case 'Score':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Score = Number(sValue);
                    }
                    break;
                  }
                case 'Weight':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Weight = Number(sValue);
                    }
                    break;
                  }
                case 'WeightedScore':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.WeightedScore = Number(sValue);
                    }
                    break;
                  }

              }
            }

            sXML = sXML.replace(sXMLData, '');
            oQualitativeFactors.push(oQualitativeFactor);

          }


          for (let x of oQualitativeFactors) {
            let oFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(y => y.QualitativeFactor == x.QualitativeFactor);

            if (oFAScoringModelQualitativeView != null) {

              oFAScoringModelQualitativeView.OriginalValue = x.OriginalValue;
              oFAScoringModelQualitativeView.AdjustedValue = x.AdjustedValue;
              oFAScoringModelQualitativeView.Score = x.Score;
              oFAScoringModelQualitativeView.Weight = x.Weight;
              oFAScoringModelQualitativeView.WeightedScore = x.WeightedScore;


            }           


          }

        }

      }


      if (this.IsNullOrEmpty(this.__sValue))
      {
        let sFormulaString = this.__oFAScoringModelQualitativeView.find(x => x.FAScoreCard != null).ScoreCardGroupFormula;
        let iSumOfWeightedScore: number = 0;
        


        //if (this.IsNullOrEmpty(sFormulaString)) {
        //  for (let x of this.__oFAScoringModelQualitativeView.filter(x => x.FAScoreCard != null)) {
        //    iSumOfWeightedScore = iSumOfWeightedScore + x.WeightedScore;
        //  }

        //  sQualitativeScore = iSumOfWeightedScore.toString();
        //}
        //else {
        //  sFormulaString = sFormulaString.replace("=", "");

        //  for (let x of this.__oFAScoringModelQualitativeView.filter(x => x.FAScoreCard != null))
        //  {
        //    var regexScore: RegExp = new RegExp(x.ScoreIndex, "g");
        //    var regexWeight: RegExp = new RegExp(x.WeightIndex, "g");

        //    sFormulaString = sFormulaString.replace(regexScore, x.Score.toString());
        //    sFormulaString = sFormulaString.replace(regexWeight, x.Weight.toString());
        //  }

        //  sQualitativeScore = sFormulaString;
          
        //}

        let oIndexWithScore: FinancialIndexWithScore[] = [];

        for (let oGroupFactor of this.__oFAScoringModelQualitativeView.filter(x => x.FAScoreCard != null)) {

          let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
          oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
          oFinancialIndexWithScore.Score = oGroupFactor.Score;

          oIndexWithScore.push(oFinancialIndexWithScore);

          let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
          oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
          oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

          oIndexWithScore.push(oFinancialIndexWithWeight);
          
        }

        let oAPIParamSA: APIParamSA = new APIParamSA();
        oAPIParamSA.QualitativeWeightedScore = sFormulaString;
        oAPIParamSA.FinancialIndexWithScore = oIndexWithScore;
        oAPIParamSA.sParam = this.__sScoringModelName;

        this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateQualitativeWeightedScoreRating").then(
          result => this.OnSuccessCalculateQualitativeWeightedScoreRating(result)
        ).
          catch(error => this.OnErrorCalculateQualitativeWeightedScoreRating(error))

      }
      else {
        this.PopulateScoreAnalysisData();
      }

    }
    this.__bIsLoadingVisible = false;
  }

  public OnErrorCalculateQualitativeWeightedScoreRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessCalculateQualitativeWeightedScoreRating(response: any) {

    if (response != null) {
      let oResponse: QualitativeWeightedScoreResponse = response;

      this.__sWeightedQualitativeRating = oResponse.Rating;
      this.__iWeightedQualitativeScore = oResponse.Score;

      this.CalculateIntrinsicScoreRating();
    }
    this.__bIsLoadingVisible = false;
  }


  public OnErrorGetScoreCardGroupScoreAnalysis(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetScoreCardGroupScoreAnalysis(response: any) {

    if (response != null) {
      let oResponse: ScoreCardGroupScoreAnalysis[] = response;


      for (let oScoreAnalysis of oResponse)
      {
        let oExistSA: ScoreCardGroupScoreAnalysis = this.__oFAScoreCardGroupScoreAnalysis.find(x => x.Id == oScoreAnalysis.Id);

        oExistSA.Rating = oScoreAnalysis.Rating;
        oExistSA.Score = oScoreAnalysis.Score;
        oExistSA.WeightedScore = oScoreAnalysis.WeightedScore;
        oExistSA.WeightedScoreDummy = oScoreAnalysis.Score;
      }

      this.CalculateWeightedFinancialRating()

    }
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetFAScoringModelFinancialForNewScore(response: any) {

    if (response != null) {
      let oFAScoringModelFinancialView: FAScoringModelFinancialView = response;

      let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == oFAScoringModelFinancialView.lFAScoringModelFinancialId);

      if (!this.IsNullOrUndefined(oExistFAScoringModelFinancialView)) {
        oExistFAScoringModelFinancialView.Score = oFAScoringModelFinancialView.Score;
        oExistFAScoringModelFinancialView.WeightedScore = oExistFAScoringModelFinancialView.Score * oExistFAScoringModelFinancialView.Weight;
      }

    }
    this.__bIsLoadingVisible = false;
  }

  public SliderValueChanged(e: any) {
    this.__bIsLoadingVisible = true;
    let oScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis = this.__oFAScoreCardGroupScoreAnalysis.find(x => x.Id == e);
    oScoreCardGroupScoreAnalysis.WeightedScore = oScoreCardGroupScoreAnalysis.WeightGuage * oScoreCardGroupScoreAnalysis.WeightedScoreDummy / 100;
    this.CalculateTotalWeightGauge();
    this.CalculateWeightedFinancialRating();
    this.__bIsLoadingVisible = false;

  }

  public CalculateTotalWeightGauge() {
    this.__iTotalWeightGauge = 0;
    for (let x of this.__oFAScoreCardGroupScoreAnalysis) {
      this.__iTotalWeightGauge = this.__iTotalWeightGauge + x.WeightGuage;
    }    
  }

  public CalculateWeightedFinancialRating()
  {
    this.__iWeightedFinancialScore = 0;
    for (let x of this.__oFAScoreCardGroupScoreAnalysis) {
      this.__iWeightedFinancialScore = this.__iWeightedFinancialScore + x.WeightedScore;
    }

    let oAPIParamSA: APIParamSA = new APIParamSA();
    oAPIParamSA.WeightedScore = this.__iWeightedFinancialScore;
    oAPIParamSA.sParam = this.__sScoringModelName;

    this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateWeightedFinancialRating").then(
      result => this.OnSuccessGetCalculateWeightedFinancialRating(result)
    ).
      catch(error => this.OnErrorCalculateWeightedFinancialRating(error))
  }


  public OnErrorCalculateWeightedFinancialRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetCalculateWeightedFinancialRating(response: any) {

    if (response != null) {
      let oResponse: string = response;

      this.__sWeightedFinancialRating = oResponse;

      this.CalculateIntrinsicScoreRating();
     

    }
    this.__bIsLoadingVisible = false;
  }

  public CalculateIntrinsicScoreRating() {

    // calculate intrinsic rating

    let oAPIParamSA: APIParamSA = new APIParamSA();
    oAPIParamSA.sParam = this.__sScoringModelName;

    let oIndexWithScore: FinancialIndexWithScore[] = [];

    for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup != null && x.Score != null && x.Weight != null)) {
      var regexScore: RegExp = new RegExp(oGroupFactor.ScoreIndex, "g");
      var regexWeight: RegExp = new RegExp(oGroupFactor.WeightIndex, "g");

      let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
      oFinancialIndexWithScore.Score = oGroupFactor.Score;

      oIndexWithScore.push(oFinancialIndexWithScore);

      let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
      oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

      oIndexWithScore.push(oFinancialIndexWithWeight);

      let oFinancialIndexWithWeightGFV: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeightGFV.Index = oGroupFactor.GroupFormulaIndex;
      oFinancialIndexWithWeightGFV.Score = oGroupFactor.GroupFormulaValue;

      oIndexWithScore.push(oFinancialIndexWithWeightGFV);
    }

      // Weighted financial rating

    let oWeightedFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedFinancialIndexWithScore.Index = 'WGFR';
    oWeightedFinancialIndexWithScore.Score = this.__iWeightedFinancialScore;

    oIndexWithScore.push(oWeightedFinancialIndexWithScore);

    let oWeightedQualitativeIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedQualitativeIndexWithScore.Index = 'QF';
    oWeightedQualitativeIndexWithScore.Score = this.__iWeightedQualitativeScore;

    oIndexWithScore.push(oWeightedQualitativeIndexWithScore);


    oAPIParamSA.FinancialIndexWithScore = oIndexWithScore;

    this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateIntrinsicScoreRating").then(
      result => this.OnSuccessGetCalculateIntrinsicScoreRating(result)
    ).
      catch(error => this.OnErrorCalculateIntrinsicScoreRating(error))
  }

  public OnErrorCalculateIntrinsicScoreRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetCalculateIntrinsicScoreRating(response: any) {

    if (response != null) {
      let oResponse: QualitativeWeightedScoreResponse = response;

      this.__sWeightedIntrinsicRating = oResponse.Rating;
      this.__iWeightedIntrinsicScore = oResponse.Score;     

    }
    this.__bIsLoadingVisible = false;
  }

  public PopulateScoreAnalysisData() {
    if (!this.IsNullOrEmpty(this.__sValue))
    {
      let sXML: string = this.__sValue;

      sXML = sXML.replace('<ScoreAnalysis>', '');
      sXML = sXML.replace('</ScoreAnalysis>', '');

      let iDefinitionStartIndex: number = 0;
      let iDefinitionLastIndex: number = 0;
      let sColumnData: string = "";


      iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
      iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

      let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

      sXML = sXML.replace(sColumnData, '');

      // financial rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedFinancialRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedFinancialRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 26);

      this.__sWeightedFinancialRating = sColumnData.replace("<WeightedFinancialRating>", "").replace("</WeightedFinancialRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // financial score

      iDefinitionStartIndex = sXML.indexOf("<WeightedFinancialScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedFinancialScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 25);

      this.__iWeightedFinancialScore = Number(sColumnData.replace("<WeightedFinancialScore>", "").replace("</WeightedFinancialScore>", ""));

      sXML = sXML.replace(sColumnData, '');
      // qualitative rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedQualitativeRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedQualitativeRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 28);

      this.__sWeightedQualitativeRating = sColumnData.replace("<WeightedQualitativeRating>", "").replace("</WeightedQualitativeRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // qualitative score

      iDefinitionStartIndex = sXML.indexOf("<WeightedQualitativeScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedQualitativeScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 27);

      this.__iWeightedQualitativeScore = Number(sColumnData.replace("<WeightedQualitativeScore>", "").replace("</WeightedQualitativeScore>", ""));

      sXML = sXML.replace(sColumnData, '');
      // intrinsic rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedIntrinsicRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedIntrinsicRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 26);

      this.__sWeightedIntrinsicRating = sColumnData.replace("<WeightedIntrinsicRating>", "").replace("</WeightedIntrinsicRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // intrinsic score

      iDefinitionStartIndex = sXML.indexOf("<WeightedIntrinsicScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedIntrinsicScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 25);

      this.__iWeightedIntrinsicScore = Number(sColumnData.replace("<WeightedIntrinsicScore>", "").replace("</WeightedIntrinsicScore>", ""));

      sXML = sXML.replace(sColumnData, '');

      if (sScoringModel == this.__sScoringModelName) {
        
        let oFinancialColumns: string[] = ['Id', 'ScoreCardGroup', 'Score', 'Rating', 'WeightGuage', 'WeightedScore', 'WeightedScoreDummy','Formula'];

        let iStartIndex: number = 0;
        let iLastIndex: number = 0;
        let sXMLData: string = '';
        let sNode: string = '';
        let iColumnStartIndex: number = 0;
        let iColumnLastIndex: number = 0;
        let sColumnValue: string = "";
        let sValue: any = "";
        let sData: string = '';

        let oFinancialFactors: any[] = [];

        while (sXML.trim() != '') {
          let oFinancialFactor: any = {};

          iStartIndex = sXML.indexOf("<Data>");
          iLastIndex = sXML.indexOf("</Data>");

          sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

          sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

          for (let oColumn of oFinancialColumns) {
            iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

            if (iColumnStartIndex >= 0) {
              iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

              sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

              sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

            }

            switch (oColumn) {
              case 'Id':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Id = Number(sValue);
                  }
                  break;
                }
              case 'ScoreCardGroup':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.ScoreCardGroup = sValue;
                  }
                  break;
                }
              case 'Score':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Score = Number(sValue);
                  }
                  break;
                }
              case 'Rating':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Rating = sValue;
                  }
                  break;
                }
              case 'WeightGuage':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightGuage = Number(sValue);
                  }
                  break;
                }
              case 'WeightedScore':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightedScore = Number(sValue);
                  }
                  break;
                }
              case 'WeightedScoreDummy':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightedScoreDummy = Number(sValue);
                  }
                  break;
                }
              case 'Formula':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Formula = sValue;
                  }
                  break;
                }

            }
          }

          sXML = sXML.replace(sXMLData, '');
          oFinancialFactors.push(oFinancialFactor);

        }

        this.__oFAScoreCardGroupScoreAnalysis = [];

        for (let x of oFinancialFactors) {
          let oFAScoringModelFinancialView: ScoreCardGroupScoreAnalysis = new ScoreCardGroupScoreAnalysis();

          oFAScoringModelFinancialView.Id = x.Id;
          oFAScoringModelFinancialView.Score = x.Score;
          oFAScoringModelFinancialView.Rating = x.Rating;
          oFAScoringModelFinancialView.WeightGuage = x.WeightGuage;
          oFAScoringModelFinancialView.WeightedScore = x.WeightedScore;
          oFAScoringModelFinancialView.Formula = x.Formula;
          oFAScoringModelFinancialView.WeightedScoreDummy = x.Score;
          oFAScoringModelFinancialView.ScoreCardGroup = x.ScoreCardGroup;

          this.__oFAScoreCardGroupScoreAnalysis.push(oFAScoringModelFinancialView);

        }

      }

    }
  }

  public replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  public replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100');
    return strToBeReturned;
  }

  public URLEncode(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/&/g, '%26');
    return strToBeReturned;
  }


  public IsNullOrEmpty(sValue: string) {
    if (sValue == undefined || sValue == '' || sValue == null || sValue.trim() == '') {
      return true;
    }
    else {
      return false;
    }
  }

  public IsNullOrUndefined(iValue: any) {
    if (iValue == undefined || iValue == null) {
      return true;
    }
    else {
      return false;
    }
  }

  public IsTrue(oValue: any) {
    if (oValue != undefined && (oValue == 1 || oValue.toString() == 'true')) {
      return true;
    }
    else {
      return false;
    }
  }

  public format(value) {
    return value + "%";
  }

  private replaceAllSpecialCharacters(str: any) {
    let strToBeReturned = "";

    strToBeReturned = str.replace(/backslaaash/g, "\\\\").replace(/annnd/g, "&").replace(/pluuuus/g, "+").replace(/cln100/g, ":").replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/hassh/g, "#")
      .replace(/aaat/g, "@").replace(/staaar/g, "*").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/exclammmaation/g, "!").replace(/quoootes/g, '"').replace(/ampersand/g, "&"); //FB 30669 - Vidya

    return strToBeReturned;
  }
}
